import React, { useEffect, useState } from 'react'
import { connect } from "react-redux";
import TopBarNav from '../common/TopBarNav'
import { getPurchaseDashboardIcon } from '../common/UtilsIcons'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent'
import Icon from 'antd/es/icon'
import { useHistory, Link as RouterLink } from 'react-router-dom'
import * as purchaseActions from '../../actions/purchase/PurchaseActions'
import * as navigationActions from '../../actions/common/NavigationActions'
import { bindActionCreators } from 'redux'
import BreadcrumbsHistory from '../common/BreadcrumbsHistory';
import { Backdrop, CircularProgress } from '@material-ui/core';
import PurchaseStyles from './PurchaseStyles';
import Typography from '@material-ui/core/Typography'
import SearchIcon from '@material-ui/icons/Search'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import { FormControl, Input, InputLabel } from '@material-ui/core'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const ClearButton = {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    height: '32px',
    width: '32px',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'white',
    color: '#7A9BC2',
    paddingTop: '35px'
}

const PurchaseDashboard = ({ classes, ...props }) => {
    const history = useHistory()
    const { match: { params } } = props;
    const [open, setOpen] = useState(false);
    const [textToFilter, setTextToFilter] = useState('')
    // const [testConnectionNvp, settestConnectionNvp] = useState('')

    useEffect(() => {
        props.navigationActions.clean_routes()
        const newRoute = {
            path: '/purchase',
            linkLegend: 'Tablero',
            urlParams: [{ key: 'supplierId', value: params.supplierId }]
        }
        handleOpen()
        props.navigationActions.add_route(newRoute)
        props.purchaseActions.fetch_Dashboard(props.userLanguage, props.userToken, params.supplierId, onError, onSuccess)
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const handleClose = () => {
        setOpen(false);
    }
    const handleOpen = () => {
        setOpen(true);
    }
    const onSuccess = () => {
        handleClose()
    }
    const onError = (err) => {
        handleClose()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    break
                case 403:
                    history.push('/forbidden')
                    break
                case 500:
                    console.log(err.response.data)
                    break
                default:
                    break
            }
        }
    }

    const onSuccessFind = (response) => {
        handleClose()
        if (response.success) {
            toast.success(response.message, { className: classes.toastSuccess })
        } else {
            toast.info(response.message, { className: classes.toastSuccess })
        }
    }

    const handleSubmit = () => {
        if (textToFilter !== '') {
            handleOpen()
            //props.purchaseActions.fecth_oc_by_status(props.userLanguage, props.userToken, params.supplierId, params.status, "", "", textToFilter, onError, onSuccess)
            props.purchaseActions.find_Quadrant(props.userLanguage, props.userToken, params.supplierId, textToFilter, onError, onSuccessFind)
        }
    }

    const handleIsDiasabled = (invoiceStatus) => {
        switch (invoiceStatus) {
            case 27: return false;
            case 28: return false;
            default: return false;
        }
    }

    // const handleTestConnectionNvp = () => {
    //     props.purchaseActions.test_Connect_Nvp(testConnectionNvp, "texto de prueba")
    // }

    return (
        <div>
            <TopBarNav />
            <br />
            <BreadcrumbsHistory />
            <br />
            <Container maxWidth="lg" className={classes.root}>
                <Backdrop className={classes.backdrop} open={open}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Grid container item xs={12} spacing={3} >
                    <Grid item xs={7} style={{ textAlign: 'right' }}>
                        <br />
                        <h5>Adquisición de vehículos</h5>
                    </Grid>
                    <Grid item xs={5} style={{ textAlign: 'right' }}>
                        <FormControl >
                            <InputLabel>Buscar por OC</InputLabel>
                            <Input
                                type="text"
                                name="Busqueda de OC"
                                value={textToFilter}
                                onChange={e => setTextToFilter(e.target.value)}
                            />
                        </FormControl>
                        <Tooltip title='Buscar'>
                            <IconButton type="button" variant="contained" color="primary" onClick={() => handleSubmit()} style={ClearButton} >
                                <SearchIcon />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid container item xs={12} spacing={3}>
                        {
                            props.dashboardItems.map((itemDashboard, index) => {
                                return (
                                    <Grid item xs={4} key={index}>
                                        <Card className={classes.borderRadius}>
                                            <CardActionArea disabled={handleIsDiasabled(itemDashboard.invoiceStatus)} component={RouterLink} to={`/purchase/listByStatus/${itemDashboard.invoiceStatus}&${params.supplierId}`}>
                                                <CardHeader className={handleIsDiasabled(itemDashboard.invoiceStatus) === true ? classes.cardHeaderDisabled : classes.cardHeader}
                                                    title={itemDashboard.statusName}
                                                    titleTypographyProps={{ variant: 'h6' }}
                                                />
                                                <CardContent className={classes.dashboardAlign}>
                                                    <Icon type={getPurchaseDashboardIcon(itemDashboard.invoiceStatus)} className={handleIsDiasabled(itemDashboard.invoiceStatus) === true ? classes.dashboardIconDisabled : classes.dashboardIcon} theme="outlined" />
                                                    <br />
                                                    <br />
                                                    <Grid container item xs={12} className={classes.dashboardAlign}>
                                                        <br />
                                                        <Grid item xs={12} >
                                                            <Grid className={classes.subHeaderPadding}>
                                                                <br />
                                                                <Typography className={handleIsDiasabled(itemDashboard.invoiceStatus) === true ? classes.textDisaled : classes.text}>Total</Typography>
                                                            </Grid>
                                                            <Grid className={classes.subHeaderPadding}>
                                                                <br />
                                                                <Typography className={handleIsDiasabled(itemDashboard.invoiceStatus) === true ? classes.textDisaled : classes.text}>
                                                                    {
                                                                        handleIsDiasabled(itemDashboard.invoiceStatus) === true ? 'N/A' : itemDashboard.total
                                                                    }
                                                                </Typography>
                                                                <br />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </CardContent>
                                            </CardActionArea>
                                        </Card>
                                    </Grid>
                                )
                            }
                            )
                        }
                    </Grid>
                    <Grid item xs={12}><br /></Grid>
                </Grid>
            </Container>
            {/* <Input
                type="text"
                value={testConnectionNvp}
                onChange={(e) => settestConnectionNvp(e.target.value)}
            />
            <Button type="button" variant="outlined" onClick={handleTestConnectionNvp}>Guardar</Button> */}
            <ToastContainer />
        </div>
    )
}

const mapStateToProps = state => ({
    dashboardItems: state.PurchaseReducer.list,
    userProfile: state.UserProfileReducer.list,
    userlogin: state.LoginReducer.list,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language,
    navList: state.NavigationReducer.routeList
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
        purchaseActions: bindActionCreators(purchaseActions, dispatch),
        navigationActions: bindActionCreators(navigationActions, dispatch)
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(PurchaseStyles)(PurchaseDashboard))